<template>
  <div id="taskDetailsSettings">
    <v-layout wrap class="pr-4 pl-4 mt-4">
      <v-flex xs12 class="button-container pr-0 text-xs-right">
        <div class="d-inline-flex" v-if="selectedData">
          <v-btn class="pf-btn pf-btn-cancel" @click="reset">
            <v-icon size="16" class="pr-1">cancel</v-icon>
            <div>Cancel</div>
          </v-btn>
          <v-btn class="pf-btn pf-btn-save" @click="save">
            <v-icon size="16" class="pr-1">check_circle</v-icon>
            <div>Save</div>
          </v-btn>
        </div>
      </v-flex>
    </v-layout>
    <p class="ml-4 mb-4 pf-menu-text">Select the fields to be listed in the task details form.</p>
    <v-layout wrap class="flex-column pr-4 pl-4">
      <v-switch
          v-model="selectAll"
          @change="toggleSelectAll()"
          label="Select All"
          class="pr-4 pl-1 mt-0">
      </v-switch>
      <v-layout wrap class="row">
        <v-flex pl-0 v-for="(setting, i) in settings" :key="i" sm6>
          <div>
            <v-checkbox class="ma-0" :label="settingLabels[i]" v-model="settings[i]" color="teal" @change="changedData(); updateSelectAll();"></v-checkbox>
          </div>
        </v-flex>
      </v-layout>
    </v-layout>
    <v-layout wrap class="pr-4 pl-4 mt-4">
      <v-flex xs12 class="button-container pr-0 text-xs-right">
        <div class="d-inline-flex" v-if="selectedData">
          <v-btn class="pf-btn pf-btn-cancel" @click="reset">
            <v-icon size="16" class="pr-1">cancel</v-icon>
            <div>Cancel</div>
          </v-btn>
          <v-btn class="pf-btn pf-btn-save" @click="save">
            <v-icon size="16" class="pr-1">check_circle</v-icon>
            <div>Save</div>
          </v-btn>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
/* global session store  */
import { mask } from 'vue-the-mask';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import { quillEditor } from 'vue-quill-editor';
import swal from 'sweetalert2';
import { mapGetters } from 'vuex';
import { update, getCollection, remove } from '../helpers/helpers';

export default {
  name: 'configuration',
  directives: { mask },
  components: {
    quillEditor
  },
  data: () => ({
    selectAll: false,
    entity: 'Agency',
    settingsBackup: {},
    selectedData: false,
    settings: {
      first_meeting: true,
      writing_coach: true,
      writing_reminder: true,
      text_completed: true,
      text_approved: true,
      received_photos: true,
      template_choice: true,
      themes: true,
      profile_sent_layout: true,
      sent_first_proof: true,
      video_order_form: true,
      survey_sent: true,
      survey_received: true,
      pdf_flipbook_epub_uploaded: true,
      camera_ordered: true,
      camera_shipped: true,
      camera_tracking_no: true,
      video_production_no: true,
      submitted_photos: true,
      submitted_videos: true,
      website_live: true,
      profile_complete: true,
      profile_proof_approved: true,
      featured_in_social_media: true,
      blurb_book_ordered: true,
      blurb_book_delivery: true,
      printed_profiles_ordered: true,
      printed_profile_tracking_no: true,
      profiles_shipping: true,
      profiles_ship_address: true,
      printed_profiles_delivery_date: true,
      video_camera_received: true,
      entered_video_camera_received: true,
      video_profile_sent_approval: true,
      video_profile_approved: true,
      video_profile_submitted_all_videos: true,
      video_profile_submitted_all_photos: true,
      wants_social_media: true,
      done_social_media: true,
      url_ordered: true,
      submit_videos_via: true,
      submit_photos_via: true,
      notes: true
    },
    settingLabels: {
      first_meeting: 'First Meeting',
      writing_coach: 'Writing Coach',
      writing_reminder: 'Email parents a writing reminder',
      text_completed: 'Writing is completed',
      text_approved: 'Text is approved',
      received_photos: 'Received Photos for Layout',
      template_choice: 'Template Choice',
      themes: 'Themes',
      profile_sent_layout: 'Profile sent to Layout',
      sent_first_proof: 'Sent first proof',
      video_order_form: 'Video Order Form sent',
      survey_sent: 'Satisfaction Survey sent',
      survey_received: 'Satisfaction Survey Received',
      pdf_flipbook_epub_uploaded: 'PDF,Flipbook,ePub Uploaded into PF',
      camera_ordered: 'Video Camera Ordered',
      camera_shipped: 'Video Camera Shipped',
      camera_tracking_no: 'Tracking number for video Camera',
      video_production_no: 'Video Production Number',
      submitted_photos: 'Parents have submitted all Photos for video',
      submitted_videos: 'Parents have submitted all videos',
      website_live: 'Parent\'s Website is Live',
      profile_complete: 'Profile is Complete',
      profile_proof_approved: 'Profile Proof is approved',
      featured_in_social_media: 'Featured in PF social media',
      blurb_book_ordered: 'Blurb Book Ordered',
      blurb_book_delivery: 'Blurb Book - Estimated Delivery',
      printed_profiles_ordered: 'Printed Profiles Ordered',
      printed_profile_tracking_no: 'Printed Profile tracking number',
      profiles_shipping: 'Profiles are shipping',
      profiles_ship_address: 'Printed profile ship to address',
      printed_profiles_delivery_date: 'Printed Profile Delivery Date',
      video_camera_received: 'Video Camera Received from Parents',
      entered_video_camera_received: 'Entered date video camera was received',
      video_profile_sent_approval: 'Video Profile Sent for Approval',
      video_profile_approved: 'Video Profile Approved',
      video_profile_submitted_all_videos: 'Parents have submitted all videos',
      video_profile_submitted_all_photos: 'Parents have submitted all Photos for video',
      wants_social_media: 'Family Wants Social Media',
      done_social_media: 'Social Media Implemented',
      url_ordered: 'Date URL Ordered',
      submit_videos_via: 'Photos for Video are submitted via',
      submit_photos_via: 'Family is submitting video clips via',
      notes: 'Important Notes'
    }
  }),
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  computed: {
    Agency: {
      set (value) {
        store.commit('setAgency', value);
      },
      get () {
        return store.state.Agency;
      }
    }
  },
  created () {
    window.getApp.$emit('pageSubHeader', 'Settings');
    if (this.Agency && this.Agency.task_details_settings && Object.keys(this.Agency.task_details_settings).length) {
      this.settings = this.Agency.task_details_settings;
    }
    /* Add settings.text_completed if not there - Newly added */
    if (typeof this.settings.text_completed === 'undefined') {
      this.settings.text_completed = true;
    }

    this.settingsBackup = JSON.parse(JSON.stringify(this.settings));
    this.updateSelectAll();
  },
  methods: {
    toggleSelectAll () {
      this.changedData();
      Object.keys(this.settings).forEach(x => {
        this.settings[x] = this.selectAll;
      });
    },
    updateSelectAll () {
      // Set SelectAll if all checked
      let trueCount = 0;
      Object.keys(this.settings).forEach(x => {
        if (this.settings[x]) trueCount++;
      });
      if (Object.keys(this.settings).length === trueCount) {
        this.selectAll = true;
      } else {
        this.selectAll = false;
      }
    },
    changedData () {
      this.selectedData = true;
    },
    hideButtons () {
      this.selectedData = false;
    },
    reset () {
      this.settings = JSON.parse(JSON.stringify(this.settingsBackup));
      this.hideButtons();
      this.updateSelectAll();
    },
    async save () {
      this.selectedData = true;
      if (Object.keys(this.settings).length) {
        this.Agency.task_details_settings = this.settings;
      }
      let { error, data, status } = await update('Agency', this.Agency, 'Me');
      if (error) {
        console.log('error', error);
      } else {
        swal.fire({
          type: 'success',
          title: 'Task details settings updated successfully',
          showConfirmButton: false,
          timer: 2500,
          onClose: () => {
            this.hideButtons();
          }
        });
      }
    }
  }
};
</script>

<style lang="css" scoped>
 #taskDetailsSettings >>> .accent--text {
    color: #019d8c !important;
    caret-color: #019d8c !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/taskDetailsSettings.vue